
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "richTextComponents": [
    {
      "name": "PageLoanOffers",
      "component": "PageLoanOffers"
    },
    {
      "name": "PageLoanCalculator",
      "component": "PageLoanCalculator"
    },
    {
      "name": "Button",
      "component": "StoryblokButton",
      "props": {
        "class": "my-4"
      }
    },
    {
      "name": "Image",
      "component": "StoryblokImage"
    },
    {
      "name": "Table",
      "component": "ComponentTable"
    },
    {
      "name": "Gallery",
      "component": "ComponentGallery"
    },
    {
      "name": "CTAText",
      "component": "ComponentCTAText"
    },
    {
      "name": "Quote",
      "component": "ComponentQuote"
    },
    {
      "name": "Accordion",
      "component": "ComponentAccordion"
    },
    {
      "name": "InternalLinks",
      "component": "ComponentInternalLinks"
    },
    {
      "name": "CheckedList",
      "component": "ComponentRichtextCheckedList"
    },
    {
      "name": "MagazineArticleItem",
      "component": "ComponentStoryblokBlogArticleItem"
    },
    {
      "name": "SPZCalculator",
      "component": "ComponentSPZCalculator"
    },
    {
      "name": "AdviserArticleItem",
      "component": "ComponentAdviserArticleItem"
    },
    {
      "name": "ListTiles",
      "component": "ComponentListTiles"
    },
    {
      "name": "RichtextTooltip",
      "component": "ComponentRichtextTooltip"
    },
    {
      "name": "Video",
      "component": "ComponentVideo"
    }
  ]
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/codebuild/output/src2763657869/src/nuxt-porovnej24/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
